export default "__VITE_ASSET__lqfwX_ax__"